export default __webpack_public_path__ + "media/images/white-orange-pattern-f8d60a203d8ac865706fd608f9a6c694.png";